export default __webpack_public_path__ + "static/media/petCare.ec5d7e29.svg";